import { Box, Skeleton, Stack } from "@mui/material";

const ChatMessageShimmer = () => {
  return (
    <Box sx={{ p: 2, width: '100%' }}>
      <Stack spacing={3}>

        {/* Receiver Message */}
        <Box sx={{ display: "flex", alignItems: "flex-end", gap: 1 }}>
          <Skeleton variant="circular" width={36} height={36} />
          <Skeleton variant="rounded" width="20%" height={32} />
        </Box>

        {/* Sender Message */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end", gap: 1 }}>
          <Skeleton variant="rounded" width="20%" height={32} />
          <Skeleton variant="circular" width={36} height={36} />
        </Box>

        {/* Receiver Message */}
        <Box sx={{ display: "flex", alignItems: "flex-end", gap: 1 }}>
          <Skeleton variant="circular" width={36} height={36} />
          <Skeleton variant="rounded" width="30%" height={32} />
        </Box>

        {/* Sender Message */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end", gap: 1 }}>
          <Skeleton variant="rounded" width="25%" height={32} />
          <Skeleton variant="circular" width={36} height={36} />
        </Box>

        {/* Sender Message - long one */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end", gap: 1 }}>
          <Skeleton variant="rounded" width="40%" height={40} />
          <Skeleton variant="circular" width={36} height={36} />
        </Box>

        {/* Input field shimmer */}
        <Box sx={{ display: "flex", mt: 3 }}>
          <Skeleton variant="rectangular" width="100%" height={50} />
        </Box>
      </Stack>
    </Box>
  );
};

export default ChatMessageShimmer;
